import { useLingui } from '@lingui/react';
import { tableSlotId } from '@luminovo/apps-types';
import { describeTableView, type RowData, type Table } from '@luminovo/data-stack';
import type { ReactElement } from 'react';

import type { TableAppSlot } from '../tableAppSlot';
import { AppButtonMenu } from './AppButtonMenu';

/** A table slot's Apps menu. Each button gets the table's view and the slot's page params. */
export function TableAppsMenu<TData extends RowData>({
    table,
    appSlot,
}: {
    table: Table<TData>;
    appSlot: TableAppSlot;
}): ReactElement | null {
    const { i18n } = useLingui();
    const params = { ...describeTableView(table), ...appSlot.params };
    return <AppButtonMenu slotId={tableSlotId(appSlot.name)} params={params} locale={i18n.locale} />;
}
